import {
  loadLanguageAsync
} from "@/lang";
import * as types from "../mutation-types";

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    apiInt: process.env.NODE_ENV !== 'production' ? 'https://stagingbt.winner.ro' : '',
    apiVersion: 'api/v1',
    wsUrl: location.hostname,
    wsProto: location.protocol == "http:" ? "ws:" : "wss:",
    defLanguage: "en",
    fromURI: null,
  },
  // -----------------------------------------------------------------
  getters: {
    defLanguage: state => state.defLanguage,
    fromURI: state => state.fromURI,
    apiUrl: (state) => {
      if (state.apiVersion !== '') {
        return state.apiInt + "/" + state.apiVersion;
      }
      return state.apiInt;
    },
    wsUrl: (state) => {
      if (process.env.NODE_ENV !== 'production') {
        return 'wss://stagingbt.winner.ro/api/v1';
      }
      if (state.apiVersion !== '') {
        return `${state.wsProto}//${state.wsUrl}/${state.apiVersion}`;
      }
      return state.wsUrl;
    },
  },
  // -----------------------------------------------------------------
  mutations: {
    [types.SET_LANGUAGE](state, lang) {
      state.defLanguage = lang;
    },
    [types.SET_FROM](state, from) {
      state.fromURI = from;
    },
  },
  // -----------------------------------------------------------------
  actions: {
    setLanguage: (context, lang) => {
      loadLanguageAsync(lang).then(() => {
        context.commit(types.SET_LANGUAGE, lang);
      });
    },
    setFromURI: (context, from) => {
      context.commit(types.SET_FROM, from);
    },
  }
};
